"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.3333 34.0833H39.1666V14.3542C39.17 14.0433 39.0807 13.7385 38.91 13.4788C38.7393 13.219 38.4949 13.016 38.2083 12.8958C37.9212 12.7837 37.6082 12.7555 37.3057 12.8145C37.0032 12.8735 36.7238 13.0173 36.4999 13.2292L30.3749 19.2083C30.0766 19.4984 29.9056 19.8952 29.8998 20.3112C29.8939 20.7273 30.0536 21.1287 30.3437 21.4271C30.6337 21.7255 31.0305 21.8964 31.4466 21.9022C31.8627 21.9081 32.2641 21.7484 32.5624 21.4583L36.0208 18.0625V34.0833H31.8541C31.4397 34.0833 31.0423 34.248 30.7492 34.541C30.4562 34.834 30.2916 35.2314 30.2916 35.6458C30.2916 36.0602 30.4562 36.4577 30.7492 36.7507C31.0423 37.0437 31.4397 37.2083 31.8541 37.2083H43.3333C43.7477 37.2083 44.1451 37.0437 44.4381 36.7507C44.7311 36.4577 44.8958 36.0602 44.8958 35.6458C44.8958 35.2314 44.7311 34.834 44.4381 34.541C44.1451 34.248 43.7477 34.0833 43.3333 34.0833Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.0624 23.4375H16.5208V15.875C16.5208 15.4606 16.3561 15.0632 16.0631 14.7702C15.7701 14.4771 15.3727 14.3125 14.9583 14.3125C14.5439 14.3125 14.1464 14.4771 13.8534 14.7702C13.5604 15.0632 13.3958 15.4606 13.3958 15.875V23.4375H5.83325C5.41885 23.4375 5.02142 23.6021 4.7284 23.8952C4.43537 24.1882 4.27075 24.5856 4.27075 25C4.27075 25.4144 4.43537 25.8118 4.7284 26.1049C5.02142 26.3979 5.41885 26.5625 5.83325 26.5625H13.3958V34.125C13.3958 34.5394 13.5604 34.9368 13.8534 35.2299C14.1464 35.5229 14.5439 35.6875 14.9583 35.6875C15.3727 35.6875 15.7701 35.5229 16.0631 35.2299C16.3561 34.9368 16.5208 34.5394 16.5208 34.125V26.5625H24.0624C24.4768 26.5625 24.8742 26.3979 25.1673 26.1049C25.4603 25.8118 25.6249 25.4144 25.6249 25C25.6249 24.5856 25.4603 24.1882 25.1673 23.8952C24.8742 23.6021 24.4768 23.4375 24.0624 23.4375Z",
    fill: fill
  }));
};

exports["default"] = _default;